import { Component } from 'react';
import React from 'react';
import ReactDOM from 'react-dom';
import VstToast from './VstToast';

import CustomEvent from 'custom-event';
import { TransitionGroup, Transition } from 'react-transition-group';

const toastMethods = () => {
  let _toasts = [];

  const defaultOptions = () => ({
    id: `vst-toast-${Math.random()}`,
    timeout: 5000,
    type: 'info',
    horizontalPosition: 'center',
    verticalPosition: 'top',
  });

  const renderToasts = () => {
    const event = new CustomEvent('_vstui_add_toast', {});
    document.dispatchEvent(event);
  };

  class VstToastDom extends Component {
    constructor() {
      super();
      this.state = {};

      this.addToast = this.addToast.bind(this);
    }

    componentDidMount() {
      document.addEventListener('_vstui_add_toast', this.addToast);
    }

    render() {
      // We need first toast options to understand where to position our toasts
      const firstToastOptions = _toasts.length > 0 ? _toasts[0] : {};
      return (
        <span className="vst-toast-dom" role="alert">
          <div>
            {this.renderToastGroup('left', 'top')}
            {this.renderToastGroup('center', 'top')}
            {this.renderToastGroup('right', 'top')}
          </div>
          <div>
            {this.renderToastGroup('left', 'bottom')}
            {this.renderToastGroup('center', 'bottom')}
            {this.renderToastGroup('right', 'bottom')}
          </div>
        </span>
      );
    }

    addToast() {
      this.forceUpdate();
    }

    filterToasts(horizontal, vertical) {
      return _toasts.filter((toast) => toast.horizontalPosition === horizontal && toast.verticalPosition === vertical);
    }

    renderToastGroup(horizontal, vertical) {
      return (
        <div>
          <TransitionGroup>
            {this.filterToasts(horizontal, vertical).map((toast) =>
              <Transition
                key={`vst-toast-portal-item-${toast.id}`}
                timeout={{ enter: 1, exit: 1000 }}
              >
                {(transitionState) => (
                  <VstToast
                    {...toast}
                    transitionState={transitionState}
                  />
                )}
              </Transition>
            )}
          </TransitionGroup>
        </div>
      );
    }

  }

  try {
    document.addEventListener('DOMContentLoaded', () => {
      try {
        const node = document.createElement('div');
        node.className = 'vst-toast-container-portal';
        document.body.appendChild(node);

        ReactDOM.render(
          <VstToastDom />,
          node
        );
      } catch (e) {
        // Toats won't work, but any app still will in < ie9
      }
    });
  } catch (e) {
    // document is not defined
  }

  const dismiss = (id) => {
    _toasts = _toasts.filter((toast) => toast.id !== id);
    renderToasts();
  };

  const dismissAll = () => {
    _toasts = [];
    renderToasts();
  };

  const notify = (description, options = {}) => {
    let opts;
    if (typeof description === 'string') {
      opts = Object.assign({}, defaultOptions(), { description }, options);
    } else {
      opts = Object.assign({}, defaultOptions(), description);
      opts.originalOnDismiss = opts.onDismiss;
    }
    opts.onDismiss = () => {
      if (opts.originalOnDismiss) {
        opts.originalOnDismiss();
      }
      dismiss(opts.id);
    }
    _toasts.push({
      ...opts
    });
    renderToasts();
  };

  return {
    notify, dismiss, dismissAll
  };
};

export default toastMethods();
